import { Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

interface SectionTitleProps {
  title: string;
  description: string;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({ title, description }) => {
  const descriptionComponent = useBreakpointValue({
    base: <></>,
    sm: (
      <Text fontSize={Typography['fontsize.md']} color="neutral.dark">
        {description}
      </Text>
    ),
  });

  return (
    <VStack space={Spacing['stack.quarck']}>
      <Text
        fontSize={{ base: Typography['fontsize.md'], sm: Typography['fontsize.lg'] }}
        variant="semibold">
        {title}
      </Text>
      {descriptionComponent}
    </VStack>
  );
};
